import React, { useState } from 'react';
import styled from 'styled-components';
import axios from 'axios';
import { Link } from 'react-router-dom';
// import { getFunctions, httpsCallable } from "firebase/functions"; // Import Firebase functions - Replaced by central import

// Import Firebase functions correctly
// import { functions as firebaseFunctionsInstance } from '../firebase'; // Previous import
// import { functions } from '../firebaseConfig';
// import { httpsCallable } from "firebase/functions";

// Import our isolated Firebase Functions helper instead
import { callFunction } from '../firebaseFunctions';

// No longer need this debug log
// console.log("Firebase Functions instance:", functions);

// Firebase app initialization should be done in your main firebase.js or similar
// For this component, we assume firebase is initialized and we can get functions instance.
// import firebaseApp from './firebase'; // Adjust path to your Firebase init file
// const functions = getFunctions(firebaseApp);

// Use direct Firebase emulator URL - this was working before
const BASE_API_URL = 'http://localhost:5001/passport-creative/us-central1/api';

const SentimentAnalyzerContainer = styled.div`
  padding: var(--spacing-xxl) 0;
`;

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 var(--spacing-lg);
`;

const PageTitle = styled.h1`
  text-align: center;
  margin-bottom: var(--spacing-md);
  
  span {
    color: var(--accent-blue);
  }
`;

const IntroText = styled.p`
  text-align: center;
  max-width: 800px;
  margin: 0 auto var(--spacing-xl);
  font-size: 1.2rem;
  color: var(--text-light);
`;

const TabContainer = styled.div`
  margin-bottom: var(--spacing-xl);
`;

const TabButtons = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: var(--spacing-xl);
`;

const TabButton = styled.button`
  padding: var(--spacing-md) var(--spacing-lg);
  background: ${props => props['data-active'] ? 'var(--accent-blue)' : 'white'};
  color: ${props => props['data-active'] ? 'white' : 'var(--text)'};
  border: 1px solid var(--accent-blue);
  border-radius: 4px;
  margin: 0 var(--spacing-sm);
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:hover {
    background: ${props => props['data-active'] ? 'var(--accent-blue)' : 'rgba(0, 102, 204, 0.1)'};
  }
`;

const FormContainer = styled.div`
  background: white;
  border-radius: 8px;
  padding: var(--spacing-xl);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  margin-bottom: var(--spacing-xl);
`;

const InputGroup = styled.div`
  margin-bottom: var(--spacing-lg);
`;

const Label = styled.label`
  display: block;
  margin-bottom: var(--spacing-sm);
  font-weight: 500;
`;

const TextInput = styled.input`
  width: 100%;
  padding: var(--spacing-md);
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 1rem;
`;

const TextArea = styled.textarea`
  width: 100%;
  padding: var(--spacing-md);
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 1rem;
  min-height: 150px;
  resize: vertical;
`;

const SubmitButton = styled.button`
  background: var(--accent-blue);
  color: white;
  border: none;
  border-radius: 4px;
  padding: var(--spacing-md) var(--spacing-xl);
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s ease;
  
  &:hover {
    background: #0055aa;
  }
  
  &:disabled {
    background: #cccccc;
    cursor: not-allowed;
  }
`;

const ResultContainer = styled.div`
  background: white;
  border-radius: 8px;
  padding: var(--spacing-xl);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  margin-top: var(--spacing-xl);
`;

const ResultTitle = styled.h3`
  margin-bottom: var(--spacing-md);
  color: var(--text);
`;

const SentimentCard = styled.div`
  background: ${props => {
    if (props.sentiment === 'positive') return 'rgba(76, 175, 80, 0.1)';
    if (props.sentiment === 'negative') return 'rgba(244, 67, 54, 0.1)';
    return 'rgba(255, 152, 0, 0.1)';
  }};
  border-left: 4px solid ${props => {
    if (props.sentiment === 'positive') return 'var(--success)';
    if (props.sentiment === 'negative') return 'var(--error)';
    return 'var(--warning)';
  }};
  padding: var(--spacing-md);
  border-radius: 4px;
  margin-bottom: var(--spacing-md);
`;

const SentimentText = styled.p`
  font-weight: 500;
  color: ${props => {
    if (props.sentiment === 'positive') return 'var(--success)';
    if (props.sentiment === 'negative') return 'var(--error)';
    return 'var(--warning)';
  }};
  margin-bottom: var(--spacing-sm);
`;

const ScoreContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: var(--spacing-md);
  margin-top: var(--spacing-md);
`;

const ScoreItem = styled.div`
  flex: 1;
  min-width: 120px;
  background: white;
  padding: var(--spacing-sm);
  border-radius: 4px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
`;

const ScoreLabel = styled.div`
  font-size: 0.9rem;
  color: var(--text-light);
  margin-bottom: 4px;
`;

const ScoreValue = styled.div`
  font-size: 1.1rem;
  font-weight: 500;
  color: var(--text);
`;

// Styled component for highlighted keywords
const HighlightedKeywordsContainer = styled.div`
  margin-top: var(--spacing-md);
  padding-top: var(--spacing-md);
  border-top: 1px solid rgba(0,0,0,0.1);
`;

const KeywordsTitle = styled.h4`
  font-size: 1rem;
  font-weight: 500;
  color: var(--text);
  margin-bottom: var(--spacing-sm);
`;

const KeywordsList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-wrap: wrap;
  gap: var(--spacing-sm);
`;

const KeywordPill = styled.li`
  background-color: var(--accent-blue);
  color: white;
  padding: var(--spacing-xs) var(--spacing-sm);
  border-radius: 12px;
  font-size: 0.9rem;
`;

// Styled components for Themes section in Batch Results
const ThemesContainer = styled.div`
  margin-bottom: var(--spacing-xl);
  padding: var(--spacing-lg);
  background: #f9f9f9; // Light background for emphasis
  border-radius: 8px;
`;

const EmailFormContainer = styled.div`
  margin-top: var(--spacing-md, 0.75rem);
  display: flex;
  gap: var(--spacing-md, 0.75rem);
  align-items: center;
  width: 100%;
  flex-direction: row; /* Ensure horizontal layout */
  justify-content: space-between; /* Push items to opposite ends */

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

const EmailInput = styled.input`
  flex-grow: 1;
  min-width: 0; /* Allow input to shrink below its default min width */
  padding: var(--spacing-md, 0.75rem);
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 1rem;
`;

const UnlockButton = styled.button`
  background: var(--accent-orange, #f39c12); /* Fallback color if variable isn't available */
  color: white;
  border: none;
  border-radius: 4px;
  padding: var(--spacing-md, 0.75rem) var(--spacing-lg, 1rem);
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s ease;
  min-width: 160px;
  white-space: nowrap;
  display: inline-block; /* Ensure proper display */
  text-align: center;

  &:hover {
    background: #e67e22; /* Darker orange */
  }
`;

const ErrorMessage = styled.div`
  background: rgba(244, 67, 54, 0.1);
  border-left: 4px solid var(--error);
  padding: var(--spacing-md);
  border-radius: 4px;
  margin-top: var(--spacing-md);
  color: var(--error);
`;

const LoadingSpinner = styled.div`
  display: inline-block;
  width: 20px;
  height: 20px;
  border: 3px solid rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  border-top-color: white;
  animation: spin 1s ease-in-out infinite;
  margin-right: 10px;
  
  @keyframes spin {
    to { transform: rotate(360deg); }
  }
`;

// New styled components for marketing sections
const MarketingSection = styled.section`
  padding: var(--spacing-xxl) 0;
  background-color: ${props => props['data-bgcolor'] || 'transparent'};
`;

const SectionTitle = styled.h2`
  text-align: center;
  margin-bottom: var(--spacing-xl);
  font-size: 2.2rem;
  
  span {
    color: var(--accent-blue);
  }
`;

const SectionSubtitle = styled.h3`
  font-size: 1.5rem;
  margin-bottom: var(--spacing-md);
  color: var(--text);
`;

const UseCasesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: var(--spacing-xl);
  margin-top: var(--spacing-xl);
  
  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
  }
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const UseCaseCard = styled.div`
  background: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  
  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  }
`;

const UseCaseIcon = styled.div`
  width: 70px;
  height: 70px;
  border-radius: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: var(--spacing-md);
  font-size: 2rem;
  background-color: rgba(0, 102, 204, 0.1);
  color: var(--accent-blue);
`;

const UseCaseContent = styled.div`
  padding: var(--spacing-lg);
`;

const UseCaseTitle = styled.h4`
  font-size: 1.3rem;
  margin-bottom: var(--spacing-sm);
  color: var(--text);
`;

const UseCaseText = styled.p`
  color: var(--text-light);
  margin-bottom: var(--spacing-md);
`;

const FeaturesList = styled.ul`
  list-style-type: none;
  padding: 0;
  margin: 0 0 var(--spacing-lg) 0;
`;

const FeatureItem = styled.li`
  padding-left: 2rem;
  margin-bottom: var(--spacing-sm);
  position: relative;
  
  &:before {
    content: "✓";
    position: absolute;
    left: 0;
    color: var(--accent-blue);
    font-weight: bold;
  }
`;

const HowItWorksGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: var(--spacing-xl);
  margin-top: var(--spacing-xl);
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const StepCard = styled.div`
  background: white;
  border-radius: 8px;
  padding: var(--spacing-lg);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  display: flex;
  gap: var(--spacing-md);
`;

const StepNumber = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 20px;
  background-color: var(--accent-blue);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  flex-shrink: 0;
`;

const StepContent = styled.div`
  flex-grow: 1;
`;

const StepTitle = styled.h4`
  font-size: 1.2rem;
  margin-bottom: var(--spacing-sm);
  color: var(--text);
`;

const FaqContainer = styled.div`
  margin-top: var(--spacing-xl);
`;

const FaqItem = styled.div`
  margin-bottom: var(--spacing-md);
  background: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
`;

const FaqQuestion = styled.div`
  padding: var(--spacing-md) var(--spacing-lg);
  font-weight: 600;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  
  &:after {
    content: "${props => props['data-is-open'] ? '−' : '+'}";
    font-size: 1.5rem;
    color: var(--accent-blue);
  }
`;

const FaqAnswer = styled.div`
  padding: ${props => props['data-is-open'] ? `0 var(--spacing-lg) var(--spacing-md)` : '0 var(--spacing-lg)'};
  max-height: ${props => props['data-is-open'] ? '500px' : '0'};
  overflow: hidden;
  transition: all 0.3s ease;
`;

const ContactCTA = styled.div`
  background: linear-gradient(135deg, var(--accent-blue) 0%, var(--accent-turquoise) 100%);
  color: white;
  border-radius: 8px;
  padding: var(--spacing-xl);
  text-align: center;
  margin-top: var(--spacing-xxl);
`;

const CTATitle = styled.h2`
  font-size: 2rem;
  margin-bottom: var(--spacing-md);
`;

const CTADescription = styled.p`
  font-size: 1.2rem;
  max-width: 800px;
  margin: 0 auto var(--spacing-lg);
`;

const CTAButton = styled(Link)`
  display: inline-block;
  background-color: white;
  color: var(--accent-blue);
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  font-weight: 600;
  text-decoration: none;
  border: 2px solid white;
  transition: all 0.3s ease;
  
  &:hover {
    background-color: transparent;
    color: white;
  }
`;

const LimitationsCard = styled.div`
  background: rgba(255, 152, 0, 0.1);
  border-left: 4px solid var(--warning);
  padding: var(--spacing-md);
  border-radius: 4px;
  margin: var(--spacing-xl) 0;
`;

// Add new styled components for batch fields
const BatchFieldsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-md);
`;

const BatchField = styled.div`
  display: flex;
  gap: var(--spacing-md);
  align-items: center;
`;

const RemoveButton = styled.button`
  background: none;
  border: none;
  color: var(--error);
  cursor: pointer;
  font-size: 1.5rem;
  padding: 0;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  flex-shrink: 0;
  
  &:hover {
    opacity: 0.7;
  }
`;

const AddButton = styled.button`
  background: none;
  border: 1px dashed var(--accent-blue);
  color: var(--accent-blue);
  cursor: pointer;
  padding: var(--spacing-md);
  margin-top: var(--spacing-sm);
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--spacing-sm);
  width: 100%;
  
  &:hover {
    background: rgba(0, 102, 204, 0.05);
  }
  
  &:disabled {
    color: var(--text-light);
    border-color: var(--text-light);
    cursor: not-allowed;
  }
`;

// Add a simple button that doesn't rely on CSS variables
const SimpleButton = styled.button`
  background-color: #f39c12;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 10px 20px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  margin-left: 10px;
  min-width: 160px;
  
  &:hover {
    background-color: #e67e22;
  }
  
  &:disabled {
    background-color: #cccccc;
    cursor: not-allowed;
  }
`;

const TourismSentimentAnalyzer = () => {
  const [activeTab, setActiveTab] = useState('single');
  const [singleText, setSingleText] = useState('');
  const [batchFields, setBatchFields] = useState([{ id: 1, text: '' }]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [singleResult, setSingleResult] = useState(null);
  const [batchResults, setBatchResults] = useState(null);
  const [openFaq, setOpenFaq] = useState(null);
  const [isSubmittingEmail, setIsSubmittingEmail] = useState(false);
  const [emailSubmitMessage, setEmailSubmitMessage] = useState('');
  const [singleAnalysisEmail, setSingleAnalysisEmail] = useState('');
  const [batchEmailInput, setBatchEmailInput] = useState('');

  const resetResults = () => {
    setSingleResult(null);
    setBatchResults(null);
    setError('');
    setEmailSubmitMessage('');
  };

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    resetResults();
  };

  // Add functions to handle batch fields
  const addBatchField = () => {
    if (batchFields.length < 20) {
      const newId = Math.max(...batchFields.map(field => field.id), 0) + 1;
      setBatchFields([...batchFields, { id: newId, text: '' }]);
    }
  };

  const removeBatchField = (id) => {
    if (batchFields.length > 1) {
      setBatchFields(batchFields.filter(field => field.id !== id));
    }
  };

  const updateBatchField = (id, text) => {
    setBatchFields(
      batchFields.map(field => 
        field.id === id ? { ...field, text } : field
      )
    );
  };

  const analyzeSingleText = async () => {
    if (!singleText.trim()) {
      setError('Please enter some text to analyze');
      return;
    }

    setLoading(true);
    setError('');

    try {
      console.log('Sending single text analysis request:', singleText);
      
      // First try the Firebase callable function
      const result = await callFunction('analyzeSentiment', { text: singleText });
      
      if (result.success && result.data) {
        console.log("Successfully analyzed single text:", result.data);
        setSingleResult(result.data);
      } else {
        // If Firebase callable fails, try the direct API approach
        console.log('Firebase callable failed, trying direct API call');
        const response = await axios({
          method: 'post',
          url: `${BASE_API_URL}/sentiment/analyze`,
          data: { text: singleText },
          headers: { 
            'Content-Type': 'application/json',
          },
          withCredentials: false
        });
        
        console.log("Direct API call succeeded:", response.data);
        setSingleResult(response.data);
      }
    } catch (err) {
      console.error('API Error:', err);
      setError('Error analyzing text. Please try again later.');
    } finally {
      setLoading(false);
    }
  };

  const analyzeBatchTexts = async () => {
    // Gather non-empty texts from the batch fields
    const textsToAnalyze = batchFields
      .map(field => field.text.trim())
      .filter(text => text.length > 0);

    if (textsToAnalyze.length === 0) {
      setError('Please enter at least one text to analyze');
      return;
    }

    setLoading(true);
    setError('');

    try {
      // Let's try a different approach using the callFunction helper instead of direct axios
      console.log('Sending batch analysis request for', textsToAnalyze.length, 'texts:', textsToAnalyze);
      
      // First try calling the Firebase callable function directly
      const result = await callFunction('analyzeBatchSentiment', { texts: textsToAnalyze });
      
      if (result.success && result.data) {
        console.log("Successfully analyzed batch texts:", result.data);
        setBatchResults(result.data);
      } else {
        // If Firebase callable fails, try the direct API approach
        console.log('Firebase callable failed, trying direct API call');
        const response = await axios({
          method: 'post',
          url: `${BASE_API_URL}/sentiment/analyze-batch`,
          data: { texts: textsToAnalyze },
          headers: { 
            'Content-Type': 'application/json',
          },
          withCredentials: false
        });
        
        console.log("Direct API call succeeded:", response.data);
        setBatchResults(response.data);
      }
    } catch (err) {
      console.error('API Error:', err);
      setError('Error analyzing batch texts. Please try again later.');
    } finally {
      setLoading(false);
    }
  };

  const handleUnlockThemes = async (userEmail, themes, reviews) => {
    if (!userEmail || !userEmail.includes('@')) { // Simple email validation
      setEmailSubmitMessage('Please enter a valid email address.');
      return;
    }

    if (!themes || themes.length === 0) {
      setEmailSubmitMessage('No themes available to send.');
      return;
    }

    setIsSubmittingEmail(true);
    setEmailSubmitMessage('Sending your report...');

    try {
      const result = await sendEmailWithResults(userEmail, {
        reviews: reviews,
        themes: themes
      });

      if (result.success) {
        setEmailSubmitMessage(result.data.message || 'Thank you! Your report has been sent.');
        setSingleAnalysisEmail(''); // Clear email input on success
      } else {
        setEmailSubmitMessage(result.error || 'Could not send the report. Please try again.');
      }
    } catch (error) {
      console.error('Error calling sendAnalysisReport function:', error);
      setEmailSubmitMessage(error.message || 'An error occurred while sending the report.');
    } finally {
      setIsSubmittingEmail(false);
    }
  };

  const toggleFaq = (index) => {
    if (openFaq === index) {
      setOpenFaq(null);
    } else {
      setOpenFaq(index);
    }
  };

  const renderSingleResult = () => {
    if (!singleResult) return null;

    const { sentiment, interpretation, details } = singleResult;
    // Create mock themes from the highlighted positive words for single analysis
    const mockThemes = details?.highlightedPositive?.length > 0 
      ? [`Positive sentiment around "${details.highlightedPositive[0]}"`, "Full analysis available in your email"] 
      : ["Tourism sentiment analysis", "Full report in your email"];

    return (
      <ResultContainer>
        <ResultTitle>Sentiment Analysis Result</ResultTitle>
        <SentimentCard sentiment={interpretation}>
          <SentimentText sentiment={interpretation}>
            {interpretation.charAt(0).toUpperCase() + interpretation.slice(1)} Sentiment
          </SentimentText>
          <p>The text has a {interpretation} sentiment overall.</p>
          
          <ScoreContainer>
            <ScoreItem>
              <ScoreLabel>Compound Score</ScoreLabel>
              <ScoreValue>{sentiment.compound.toFixed(2)}</ScoreValue>
            </ScoreItem>
            <ScoreItem>
              <ScoreLabel>Positive</ScoreLabel>
              <ScoreValue>{sentiment.pos.toFixed(2)}</ScoreValue>
            </ScoreItem>
            <ScoreItem>
              <ScoreLabel>Negative</ScoreLabel>
              <ScoreValue>{sentiment.neg.toFixed(2)}</ScoreValue>
            </ScoreItem>
            <ScoreItem>
              <ScoreLabel>Neutral</ScoreLabel>
              <ScoreValue>{sentiment.neu.toFixed(2)}</ScoreValue>
            </ScoreItem>
          </ScoreContainer>

          {/* Display Highlighted Positive Keywords */}
          {details && details.highlightedPositive && details.highlightedPositive.length > 0 && (
            <HighlightedKeywordsContainer>
              <KeywordsTitle>Key Positive Words:</KeywordsTitle>
              <KeywordsList>
                {details.highlightedPositive.map((keyword, index) => (
                  <KeywordPill key={index}>{keyword}</KeywordPill>
                ))}
              </KeywordsList>
            </HighlightedKeywordsContainer>
          )}
          
          {/* Add email form for lead capture in single analysis */}
          <ThemesContainer style={{ marginTop: 'var(--spacing-md)' }}>
            <ResultTitle style={{ marginBottom: 'var(--spacing-sm)'}}>Get Your Full Analysis Report</ResultTitle>
            <p style={{ marginBottom: 'var(--spacing-md)'}}>Enter your email to receive a detailed analysis report with additional insights:</p>
            <EmailFormContainer>
              <EmailInput 
                type="email" 
                value={singleAnalysisEmail} 
                onChange={(e) => setSingleAnalysisEmail(e.target.value)} 
                placeholder="Enter your email address" 
                disabled={isSubmittingEmail}
              />
              <UnlockButton 
                onClick={() => handleUnlockThemes(singleAnalysisEmail, mockThemes, [singleText])} 
                disabled={isSubmittingEmail}
              >
                {isSubmittingEmail ? 'Sending...' : 'Get Full Report'}
              </UnlockButton>
            </EmailFormContainer>
            {emailSubmitMessage && <p style={{ marginTop: 'var(--spacing-sm)', color: emailSubmitMessage.startsWith('Thank you') ? 'var(--success)' : 'var(--error)' }}>{emailSubmitMessage}</p>}
          </ThemesContainer>
        </SentimentCard>
      </ResultContainer>
    );
  };

  const renderBatchResults = () => {
    if (!batchResults) return null;

    console.log("Rendering batch results:", batchResults);
    const { results, themes } = batchResults;
    const { revealed_themes, full_themes, call_to_action } = themes || { revealed_themes: [], full_themes: [], call_to_action: '' };
    console.log("Themes data:", { revealed_themes, full_themes, call_to_action });

    return (
      <ResultContainer>
        <ResultTitle>Batch Analysis Results</ResultTitle>

        {/* Themes Section */}
        {themes && (
          <ThemesContainer>
            <ResultTitle style={{ marginBottom: 'var(--spacing-sm)'}}>Key Themes Detected</ResultTitle>
            {revealed_themes && revealed_themes.length > 0 ? (
              <KeywordsList style={{ marginBottom: 'var(--spacing-md)' }}>
                {revealed_themes.map((theme, index) => (
                  <KeywordPill key={index} style={{ backgroundColor: 'var(--accent-green)' }}>{theme}</KeywordPill>
                ))}
              </KeywordsList>
            ) : (
              <p>No significant themes detected from the provided texts.</p>
            )}
            {call_to_action && <p style={{ marginBottom: 'var(--spacing-md)'}}>{call_to_action}</p>}
            
            {/* Email form with debugging */}
            <div style={{ border: '1px solid #ccc', padding: '10px', margin: '10px 0' }}>
              <p>Debug: Email form should appear below</p>
              <EmailFormContainer>
                <EmailInput 
                  type="email" 
                  value={batchEmailInput}
                  onChange={(e) => setBatchEmailInput(e.target.value)}
                  placeholder="Enter your email address" 
                  disabled={isSubmittingEmail} 
                />
                <SimpleButton 
                  onClick={() => handleUnlockThemes(batchEmailInput, full_themes, results.map(r => r.text))} 
                  disabled={isSubmittingEmail}
                >
                  {isSubmittingEmail ? 'Sending...' : 'Unlock Full Report'}
                </SimpleButton>
                
                {/* Direct HTML button as fallback */}
                <button 
                  style={{
                    backgroundColor: 'red',
                    color: 'white',
                    padding: '10px',
                    border: 'none',
                    borderRadius: '4px',
                    marginLeft: '10px',
                    cursor: 'pointer'
                  }}
                  onClick={() => handleUnlockThemes(batchEmailInput, full_themes, results.map(r => r.text))}
                >
                  Emergency Unlock Button
                </button>
              </EmailFormContainer>
              {emailSubmitMessage && <p style={{ marginTop: 'var(--spacing-sm)', color: emailSubmitMessage.startsWith('Thank you') ? 'var(--success)' : 'var(--error)' }}>{emailSubmitMessage}</p>}
            </div>
          </ThemesContainer>
        )}

        {results.map((result, index) => (
          <SentimentCard 
            key={index} 
            sentiment={result.interpretation}
            style={{ marginBottom: 'var(--spacing-md)' }}
          >
            <SentimentText sentiment={result.interpretation}>
              {result.interpretation.charAt(0).toUpperCase() + result.interpretation.slice(1)} Sentiment
            </SentimentText>
            <p><strong>Text:</strong> {result.text}</p>
            
            <ScoreContainer>
              <ScoreItem>
                <ScoreLabel>Compound Score</ScoreLabel>
                <ScoreValue>{result.sentiment.compound.toFixed(2)}</ScoreValue>
              </ScoreItem>
              <ScoreItem>
                <ScoreLabel>Positive</ScoreLabel>
                <ScoreValue>{result.sentiment.pos.toFixed(2)}</ScoreValue>
              </ScoreItem>
              <ScoreItem>
                <ScoreLabel>Negative</ScoreLabel>
                <ScoreValue>{result.sentiment.neg.toFixed(2)}</ScoreValue>
              </ScoreItem>
              <ScoreItem>
                <ScoreLabel>Neutral</ScoreLabel>
                <ScoreValue>{result.sentiment.neu.toFixed(2)}</ScoreValue>
              </ScoreItem>
            </ScoreContainer>

            {/* Display Highlighted Positive Keywords for each batch item */}
            {result.details && result.details.highlightedPositive && result.details.highlightedPositive.length > 0 && (
              <HighlightedKeywordsContainer>
                <KeywordsTitle>Key Positive Words:</KeywordsTitle>
                <KeywordsList>
                  {result.details.highlightedPositive.map((keyword, kIndex) => (
                    <KeywordPill key={kIndex}>{keyword}</KeywordPill>
                  ))}
                </KeywordsList>
              </HighlightedKeywordsContainer>
            )}
          </SentimentCard>
        ))}
      </ResultContainer>
    );
  };

  return (
    <>
      <SentimentAnalyzerContainer>
        <Container>
          <PageTitle>Tourism <span>Sentiment Analyzer</span></PageTitle>
          <IntroText>
            Analyze the sentiment of tourism reviews, social media mentions, or any text related to travel experiences.
            Our specialized analyzer understands tourism-specific language to provide more accurate results.
          </IntroText>
          
          <TabContainer>
            <TabButtons>
              <TabButton data-active={activeTab === 'single'} onClick={() => handleTabChange('single')}>
                Single Text
              </TabButton>
              <TabButton data-active={activeTab === 'batch'} onClick={() => handleTabChange('batch')}>
                Batch Analysis
              </TabButton>
            </TabButtons>
            
            {/* Single Text Analysis Form */}
            {activeTab === 'single' && (
              <FormContainer>
                <InputGroup>
                  <Label htmlFor="singleText">Enter text to analyze</Label>
                  <TextArea 
                    id="singleText"
                    value={singleText}
                    onChange={(e) => setSingleText(e.target.value)}
                    placeholder="Enter a review, social media post, or any text to analyze its sentiment..."
                  />
                </InputGroup>
                
                <SubmitButton 
                  onClick={analyzeSingleText}
                  disabled={loading}
                >
                  {loading ? (
                    <>
                      <LoadingSpinner /> Analyzing...
                    </>
                  ) : 'Analyze Sentiment'}
                </SubmitButton>
                
                {error && <ErrorMessage>{error}</ErrorMessage>}
                
                {renderSingleResult()}
              </FormContainer>
            )}
            
            {/* Batch Analysis Form */}
            {activeTab === 'batch' && (
              <FormContainer>
                <p>Add up to 20 texts to analyze in batch (reviews, comments, etc.)</p>
                <BatchFieldsContainer>
                  {batchFields.map((field) => (
                    <BatchField key={field.id}>
                      <TextArea 
                        value={field.text}
                        onChange={(e) => updateBatchField(field.id, e.target.value)}
                        placeholder="Enter text to analyze..."
                        style={{ flexGrow: 1 }}
                      />
                      {batchFields.length > 1 && (
                        <RemoveButton 
                          onClick={() => removeBatchField(field.id)}
                          title="Remove field"
                        >
                          ×
                        </RemoveButton>
                      )}
                    </BatchField>
                  ))}
                </BatchFieldsContainer>
                
                <AddButton 
                  onClick={addBatchField} 
                  disabled={batchFields.length >= 20}
                >
                  <span>+</span> Add another text field ({batchFields.length}/20)
                </AddButton>
                
                <SubmitButton 
                  onClick={analyzeBatchTexts}
                  disabled={loading}
                  style={{ marginTop: 'var(--spacing-lg)' }}
                >
                  {loading ? (
                    <>
                      <LoadingSpinner /> Analyzing...
                    </>
                  ) : 'Analyze Texts'}
                </SubmitButton>
                
                {error && <ErrorMessage>{error}</ErrorMessage>}
                
                {renderBatchResults()}
              </FormContainer>
            )}
          </TabContainer>

          <LimitationsCard>
            <strong>Free Tool Limitations:</strong> This free version allows analysis of up to 20 reviews through manual entry. For larger datasets, ongoing monitoring, or destination-wide analysis, please <Link to="/contact" style={{color: 'var(--accent-blue)'}}>contact us</Link> to discuss our custom solutions.
          </LimitationsCard>
        </Container>
      </SentimentAnalyzerContainer>

      {/* Use Cases Section */}
      <MarketingSection data-bgcolor="#f9f9f9">
        <Container>
          <SectionTitle>Who Can Benefit from <span>Tourism Sentiment Analysis?</span></SectionTitle>
          
          <UseCasesGrid>
            <UseCaseCard>
              <UseCaseContent>
                <UseCaseIcon>🏨</UseCaseIcon>
                <UseCaseTitle>Hotels & Accommodations</UseCaseTitle>
                <UseCaseText>
                  Understand guest satisfaction and identify specific areas for improvement to enhance the guest experience.
                </UseCaseText>
                <FeaturesList>
                  <FeatureItem>Analyze guest reviews from multiple platforms</FeatureItem>
                  <FeatureItem>Identify trending issues in guest feedback</FeatureItem>
                  <FeatureItem>Track sentiment changes after service improvements</FeatureItem>
                  <FeatureItem>Compare performance across properties or room types</FeatureItem>
                </FeaturesList>
              </UseCaseContent>
            </UseCaseCard>
            
            <UseCaseCard>
              <UseCaseContent>
                <UseCaseIcon>🧭</UseCaseIcon>
                <UseCaseTitle>Tour Operators</UseCaseTitle>
                <UseCaseText>
                  Discover what aspects of your tours generate the most positive reactions and which need refinement.
                </UseCaseText>
                <FeaturesList>
                  <FeatureItem>Evaluate customer satisfaction across different tours</FeatureItem>
                  <FeatureItem>Identify your most appreciated guides and experiences</FeatureItem>
                  <FeatureItem>Detect pain points before they become recurring issues</FeatureItem>
                  <FeatureItem>Gather insights for developing new tour offerings</FeatureItem>
                </FeaturesList>
              </UseCaseContent>
            </UseCaseCard>
            
            <UseCaseCard>
              <UseCaseContent>
                <UseCaseIcon>🏝️</UseCaseIcon>
                <UseCaseTitle>Destination Marketing Organizations</UseCaseTitle>
                <UseCaseText>
                  Gain a comprehensive understanding of visitor perceptions to guide strategic destination development.
                </UseCaseText>
                <FeaturesList>
                  <FeatureItem>Monitor overall destination sentiment</FeatureItem>
                  <FeatureItem>Identify strengths to highlight in marketing campaigns</FeatureItem>
                  <FeatureItem>Pinpoint infrastructure or service gaps</FeatureItem>
                  <FeatureItem>Track sentiment changes across seasons or events</FeatureItem>
                </FeaturesList>
              </UseCaseContent>
            </UseCaseCard>
            
            <UseCaseCard>
              <UseCaseContent>
                <UseCaseIcon>🍽️</UseCaseIcon>
                <UseCaseTitle>Restaurants & Eateries</UseCaseTitle>
                <UseCaseText>
                  Analyze diner feedback to perfect your menu, service, and overall dining experience.
                </UseCaseText>
                <FeaturesList>
                  <FeatureItem>Understand which dishes generate the most positive comments</FeatureItem>
                  <FeatureItem>Evaluate service quality through customer sentiment</FeatureItem>
                  <FeatureItem>Track sentiment changes after menu updates</FeatureItem>
                  <FeatureItem>Compare performance against competitors</FeatureItem>
                </FeaturesList>
              </UseCaseContent>
            </UseCaseCard>
            
            <UseCaseCard>
              <UseCaseContent>
                <UseCaseIcon>🏛️</UseCaseIcon>
                <UseCaseTitle>Attractions & Sites</UseCaseTitle>
                <UseCaseText>
                  Learn how visitors experience your attraction and what improvements would enhance satisfaction.
                </UseCaseText>
                <FeaturesList>
                  <FeatureItem>Analyze visitor comments across review platforms</FeatureItem>
                  <FeatureItem>Identify the most valued aspects of your attraction</FeatureItem>
                  <FeatureItem>Detect issues with facilities, accessibility, or information</FeatureItem>
                  <FeatureItem>Understand visitor expectations vs. reality</FeatureItem>
                </FeaturesList>
              </UseCaseContent>
            </UseCaseCard>
            
            <UseCaseCard>
              <UseCaseContent>
                <UseCaseIcon>📊</UseCaseIcon>
                <UseCaseTitle>Tourism Researchers & Consultants</UseCaseTitle>
                <UseCaseText>
                  Extract valuable insights from large volumes of tourist feedback to inform strategic recommendations.
                </UseCaseText>
                <FeaturesList>
                  <FeatureItem>Process large datasets of tourism feedback efficiently</FeatureItem>
                  <FeatureItem>Generate evidence-based insights for decision-makers</FeatureItem>
                  <FeatureItem>Support findings with quantifiable sentiment data</FeatureItem>
                  <FeatureItem>Track sentiment trends over time and across segments</FeatureItem>
                </FeaturesList>
              </UseCaseContent>
            </UseCaseCard>
          </UseCasesGrid>
        </Container>
      </MarketingSection>

      {/* How It Works Section */}
      <MarketingSection>
        <Container>
          <SectionTitle>How Our <span>Tourism-Specific Sentiment Analysis</span> Works</SectionTitle>
          
          <p style={{ textAlign: 'center', maxWidth: '800px', margin: '0 auto var(--spacing-xl)', fontSize: '1.1rem', color: 'var(--text-light)' }}>
            Unlike generic sentiment analysis tools, our analyzer is specifically tuned for tourism-related content, 
            with an enhanced understanding of industry-specific terminology and context.
          </p>
          
          <HowItWorksGrid>
            <StepCard>
              <StepNumber>1</StepNumber>
              <StepContent>
                <StepTitle>Tourism-Specific Lexicon</StepTitle>
                <p>Our analyzer uses a custom lexicon that understands tourism terminology, recognizing that phrases like "hidden gem" are highly positive while "tourist trap" carries negative connotations.</p>
              </StepContent>
            </StepCard>
            
            <StepCard>
              <StepNumber>2</StepNumber>
              <StepContent>
                <StepTitle>Smart Preprocessing</StepTitle>
                <p>Reviews are cleaned and processed to remove noise while preserving meaningful content, ensuring the analysis focuses on the substance of the feedback.</p>
              </StepContent>
            </StepCard>
            
            <StepCard>
              <StepNumber>3</StepNumber>
              <StepContent>
                <StepTitle>Contextual Understanding</StepTitle>
                <p>The system considers context when analyzing sentiment, recognizing that "the line was long but worth it" contains both negative and positive elements but is ultimately positive.</p>
              </StepContent>
            </StepCard>
            
            <StepCard>
              <StepNumber>4</StepNumber>
              <StepContent>
                <StepTitle>Comprehensive Scoring</StepTitle>
                <p>Each analysis provides multiple scores: compound (overall sentiment), positive, negative, and neutral, giving you nuanced insights into customer feedback.</p>
              </StepContent>
            </StepCard>
          </HowItWorksGrid>
          
          <div style={{ textAlign: 'center', marginTop: 'var(--spacing-xl)' }}>
            <p style={{ fontWeight: 'bold', fontSize: '1.2rem', marginBottom: 'var(--spacing-md)' }}>
              Get More from Your Analysis with Our Premium Solutions
            </p>
            <p style={{ maxWidth: '800px', margin: '0 auto' }}>
              For more advanced features including aspect-based sentiment analysis, competitor benchmarking, 
              and trend analysis over time, explore our customized solutions for tourism businesses and destinations.
            </p>
          </div>
        </Container>
      </MarketingSection>

      {/* Implementation Guide Section */}
      <MarketingSection data-bgcolor="#f9f9f9">
        <Container>
          <SectionTitle>Turning <span>Insights into Action</span></SectionTitle>
          
          <div style={{ maxWidth: '800px', margin: '0 auto var(--spacing-xl)', fontSize: '1.1rem' }}>
            <p style={{ marginBottom: 'var(--spacing-md)' }}>
              Sentiment analysis is most valuable when you apply the insights to improve your tourism offering.
              Here's how to effectively implement what you learn:
            </p>
          </div>
          
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 'var(--spacing-xl)', marginBottom: 'var(--spacing-xl)' }}>
            <div>
              <SectionSubtitle>For Hotels & Accommodations</SectionSubtitle>
              <ol style={{ paddingLeft: 'var(--spacing-lg)', lineHeight: '1.6' }}>
                <li><strong>Prioritize improvements</strong> based on the most frequently mentioned negative aspects</li>
                <li><strong>Train staff</strong> on specific service elements that receive negative sentiment</li>
                <li><strong>Highlight positive aspects</strong> in your marketing materials</li>
                <li><strong>Create action plans</strong> for different departments based on sentiment categories</li>
                <li><strong>Track sentiment trends</strong> over time to measure the impact of changes</li>
              </ol>
            </div>
            
            <div>
              <SectionSubtitle>For Tour Operators</SectionSubtitle>
              <ol style={{ paddingLeft: 'var(--spacing-lg)', lineHeight: '1.6' }}>
                <li><strong>Refine tour itineraries</strong> based on stop-by-stop sentiment analysis</li>
                <li><strong>Enhance guide training</strong> in areas receiving mixed or negative feedback</li>
                <li><strong>Adjust timing and pacing</strong> based on customer sentiment patterns</li>
                <li><strong>Develop new offerings</strong> that build on your most positively-received experiences</li>
                <li><strong>Create marketing content</strong> highlighting your highest-rated experiences</li>
              </ol>
            </div>
            
            <div>
              <SectionSubtitle>For Destinations</SectionSubtitle>
              <ol style={{ paddingLeft: 'var(--spacing-lg)', lineHeight: '1.6' }}>
                <li><strong>Identify infrastructure improvements</strong> needed based on visitor feedback</li>
                <li><strong>Guide tourism development</strong> to address experience gaps identified in reviews</li>
                <li><strong>Create targeted marketing campaigns</strong> highlighting your destination's strengths</li>
                <li><strong>Develop training programs</strong> for local businesses in areas needing improvement</li>
                <li><strong>Monitor the impact</strong> of tourism initiatives through sentiment tracking</li>
              </ol>
            </div>
            
            <div>
              <SectionSubtitle>For Restaurants & Attractions</SectionSubtitle>
              <ol style={{ paddingLeft: 'var(--spacing-lg)', lineHeight: '1.6' }}>
                <li><strong>Enhance menu items</strong> or exhibits receiving positive feedback</li>
                <li><strong>Address service issues</strong> flagged through negative sentiment analysis</li>
                <li><strong>Improve visitor information</strong> where confusion is frequently mentioned</li>
                <li><strong>Optimize pricing strategies</strong> based on value perception in reviews</li>
                <li><strong>Train staff</strong> on specific aspects of the customer experience needing improvement</li>
              </ol>
            </div>
          </div>
          
          <UseCaseCard style={{ maxWidth: '800px', margin: '0 auto' }}>
            <UseCaseContent>
              <div style={{ display: 'flex', alignItems: 'center', gap: 'var(--spacing-md)' }}>
                <UseCaseIcon style={{ margin: 0 }}>💡</UseCaseIcon>
                <SectionSubtitle style={{ margin: 0 }}>Pro Tip: Regular Monitoring</SectionSubtitle>
              </div>
              <p style={{ marginTop: 'var(--spacing-md)' }}>
                For maximum benefit, analyze sentiment on an ongoing basis rather than as a one-time exercise. Regular monitoring allows you to:
              </p>
              <FeaturesList>
                <FeatureItem>Track changes in sentiment after implementing improvements</FeatureItem>
                <FeatureItem>Identify seasonal trends or patterns in customer satisfaction</FeatureItem>
                <FeatureItem>Spot emerging issues before they become major problems</FeatureItem>
                <FeatureItem>Measure your performance relative to competitors over time</FeatureItem>
              </FeaturesList>
              <p>
                Our custom solutions include automated regular reporting and trend analysis. <Link to="/contact" style={{ color: 'var(--accent-blue)' }}>Contact us</Link> to learn more.
              </p>
            </UseCaseContent>
          </UseCaseCard>
        </Container>
      </MarketingSection>

      {/* FAQ Section */}
      <MarketingSection>
        <Container>
          <SectionTitle>Frequently Asked <span>Questions</span></SectionTitle>
          
          <FaqContainer>
            <FaqItem>
              <FaqQuestion data-is-open={openFaq === 0} onClick={() => toggleFaq(0)}>
                What makes this sentiment analyzer tourism-specific?
              </FaqQuestion>
              <FaqAnswer data-is-open={openFaq === 0}>
                <p>Our sentiment analyzer is specifically tuned for tourism content with:</p>
                <ul style={{ paddingLeft: 'var(--spacing-lg)', marginTop: 'var(--spacing-sm)' }}>
                  <li>A custom lexicon of tourism terminology with accurate sentiment weights</li>
                  <li>Special handling of context-dependent phrases common in travel reviews</li>
                  <li>Improved understanding of destination-specific references</li>
                  <li>Recognition of hospitality and service-related terminology</li>
                </ul>
                <p>This specialization results in more accurate sentiment analysis for tourism content compared to generic tools.</p>
              </FaqAnswer>
            </FaqItem>
            
            <FaqItem>
              <FaqQuestion data-is-open={openFaq === 1} onClick={() => toggleFaq(1)}>
                How accurate is the sentiment analysis?
              </FaqQuestion>
              <FaqAnswer data-is-open={openFaq === 1}>
                <p>Our tourism-specific sentiment analyzer achieves approximately 85-90% accuracy on tourism content, which is significantly higher than generic sentiment analysis tools (typically 70-75%) when applied to tourism reviews. The accuracy is highest for English-language content and may vary for other languages or heavily colloquial text.</p>
              </FaqAnswer>
            </FaqItem>
            
            <FaqItem>
              <FaqQuestion data-is-open={openFaq === 2} onClick={() => toggleFaq(2)}>
                What are the limitations of the free tool?
              </FaqQuestion>
              <FaqAnswer data-is-open={openFaq === 2}>
                <p>The free version of our tool has the following limitations:</p>
                <ul style={{ paddingLeft: 'var(--spacing-lg)', marginTop: 'var(--spacing-sm)' }}>
                  <li>Maximum of 20 reviews for batch analysis</li>
                  <li>Basic sentiment scoring without advanced features like aspect-based sentiment analysis</li>
                  <li>No historical data storage or trend analysis</li>
                  <li>No competitor benchmarking or comparative analysis</li>
                </ul>
                <p>For more comprehensive analysis, please contact us about our premium solutions.</p>
              </FaqAnswer>
            </FaqItem>
            
            <FaqItem>
              <FaqQuestion data-is-open={openFaq === 3} onClick={() => toggleFaq(3)}>
                Can I analyze reviews in languages other than English?
              </FaqQuestion>
              <FaqAnswer data-is-open={openFaq === 3}>
                <p>The free tool currently supports English content only. Our premium solutions offer multilingual sentiment analysis with support for major tourism languages including Spanish, French, German, Italian, Portuguese, Japanese, and Chinese. Custom language solutions are available for specific projects.</p>
              </FaqAnswer>
            </FaqItem>
            
            <FaqItem>
              <FaqQuestion data-is-open={openFaq === 4} onClick={() => toggleFaq(4)}>
                How do I interpret the sentiment scores?
              </FaqQuestion>
              <FaqAnswer data-is-open={openFaq === 4}>
                <p>Our sentiment analysis provides several key metrics:</p>
                <ul style={{ paddingLeft: 'var(--spacing-lg)', marginTop: 'var(--spacing-sm)' }}>
                  <li><strong>Compound score:</strong> A normalized score from -1 (extremely negative) to +1 (extremely positive) that represents the overall sentiment</li>
                  <li><strong>Positive score:</strong> The proportion of the text that expresses positive sentiment (0 to 1)</li>
                  <li><strong>Negative score:</strong> The proportion expressing negative sentiment (0 to 1)</li>
                  <li><strong>Neutral score:</strong> The proportion expressing neutral sentiment (0 to 1)</li>
                </ul>
                <p>We also provide a categorical interpretation (positive/negative/neutral) based on these scores for easier understanding.</p>
              </FaqAnswer>
            </FaqItem>
            
            <FaqItem>
              <FaqQuestion data-is-open={openFaq === 5} onClick={() => toggleFaq(5)}>
                What premium features are available?
              </FaqQuestion>
              <FaqAnswer data-is-open={openFaq === 5}>
                <p>Our premium sentiment analysis solutions include:</p>
                <ul style={{ paddingLeft: 'var(--spacing-lg)', marginTop: 'var(--spacing-sm)' }}>
                  <li><strong>Aspect-based sentiment analysis:</strong> Understand sentiment for specific aspects of your business (e.g., service, cleanliness, value)</li>
                  <li><strong>Automated review collection:</strong> Regular scraping and analysis of reviews from major platforms</li>
                  <li><strong>Trend analysis:</strong> Track sentiment changes over time with customizable reporting</li>
                  <li><strong>Competitor benchmarking:</strong> Compare your sentiment performance against competitors</li>
                  <li><strong>Large-scale analysis:</strong> Process thousands or even millions of reviews</li>
                  <li><strong>API access:</strong> Integrate sentiment analysis into your own systems</li>
                  <li><strong>Custom dashboards:</strong> Visualize sentiment data specific to your needs</li>
                </ul>
                <p>Contact us for a custom solution tailored to your specific requirements.</p>
              </FaqAnswer>
            </FaqItem>
            
            <FaqItem>
              <FaqQuestion data-is-open={openFaq === 6} onClick={() => toggleFaq(6)}>
                Is my data secure and private?
              </FaqQuestion>
              <FaqAnswer data-is-open={openFaq === 6}>
                <p>Yes, we take data security seriously. The free tool processes your data on-the-fly and does not permanently store the content of your reviews. For premium solutions, we implement enterprise-grade security measures and can offer data residency options for companies with specific compliance requirements. All data is encrypted in transit and at rest.</p>
              </FaqAnswer>
            </FaqItem>
          </FaqContainer>
        </Container>
      </MarketingSection>
      
      {/* Contact CTA Section */}
      <MarketingSection>
        <Container>
          <ContactCTA>
            <CTATitle>Ready for Deeper Tourism Insights?</CTATitle>
            <CTADescription>
              Our team can help you implement a comprehensive sentiment analysis strategy 
              tailored to your specific tourism business or destination.
            </CTADescription>
            <CTAButton to="/contact">Contact Us for a Custom Solution</CTAButton>
          </ContactCTA>
        </Container>
      </MarketingSection>
    </>
  );
};

const sendEmailWithResults = async (userEmail, emailFormData) => {
  // Use the safer callFunction helper that handles errors gracefully
  return await callFunction('sendAnalysisReport', {
    userEmail: userEmail,
    reviews: emailFormData.reviews,
    themes: emailFormData.themes
  });
};

export default TourismSentimentAnalyzer; 